import { useState } from 'react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import { UMSidebar } from '../_components';
import type { SidebarMenu } from '../_components';
import { useHybridLayers } from './hooks';
import { HybridPanel } from './HybridPanel';
import { LibraryPicker } from './LibraryPicker';
import { TopBar } from './TopBar';

export const meta = {
  title: 'Menu des couches — Hybride',
  description: 'Piste C : les couches sont organisées par phase d\'étude, et le panel n\'affiche que la sélection personnelle (sélection suggérée par défaut). Une "Bibliothèque de couches" permet d\'ajouter d\'autres couches disponibles.',
  tags: ['map', 'territory', 'po'],
  author: 'clemence.fandard',
  status: 'draft' as const,
};

export default function MenuCouchesHybride() {
  const [activeMenu, setActiveMenu] = useState<SidebarMenu | null>('layers');
  const state = useHybridLayers();

  const handleToggleMenu = (menu: SidebarMenu) => {
    setActiveMenu((prev) => (prev === menu ? null : menu));
  };

  return (
    <PrototypeStudioLayout title="UrbanMap — Menu des couches (Hybride)">
      <div style={{ display: 'flex', width: '100%', height: 'calc(100vh - 56px)', overflow: 'hidden' }}>

        <UMSidebar activeMenu={activeMenu} onToggleMenu={handleToggleMenu} />

        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
          <TopBar />

          <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
            {activeMenu === 'layers' && !state.pickerOpen && (
              <HybridPanel
                steps={state.steps}
                libraryByStep={state.libraryByStep}
                visible={state.visible}
                openStep={state.openStep}
                activeCount={state.activeCount}
                librarySize={state.librarySize}
                onOpenPicker={() => state.setPickerOpen(true)}
                onToggleVisible={state.toggleVisible}
                onToggleStep={state.toggleStep}
                onRemoveFromLibrary={state.removeFromLibrary}
                onClearAll={state.clearAll}
                onClose={() => setActiveMenu(null)}
              />
            )}

            {activeMenu === 'layers' && state.pickerOpen && (
              <LibraryPicker
                steps={state.steps}
                library={state.library}
                results={state.pickerResults}
                search={state.pickerSearch}
                stepFilter={state.pickerStep}
                catalogSize={state.catalogSize}
                librarySize={state.librarySize}
                onSearch={state.setPickerSearch}
                onSetStepFilter={state.setPickerStep}
                onToggle={state.toggleLibrary}
                onClose={() => { state.setPickerOpen(false); state.setPickerSearch(''); state.setPickerStep(null); }}
              />
            )}

            <main style={{
              flex: 1, background: '#e8ecf0',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexDirection: 'column', gap: 8,
              color: '#94a3b8', fontSize: 14,
            }}>
              <span style={{ fontSize: 40 }}>🗺</span>
              <span>Carte Mapbox (placeholder)</span>
              <span style={{ fontSize: 12 }}>
                {state.activeCount === 0
                  ? 'Aucune couche activée pour le moment'
                  : `${state.activeCount} couche${state.activeCount > 1 ? 's' : ''} activée${state.activeCount > 1 ? 's' : ''} s'afficherai${state.activeCount > 1 ? 'ent' : 't'} ici`}
              </span>
            </main>
          </div>
        </div>

      </div>
    </PrototypeStudioLayout>
  );
}
